import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Shipments from "@/pages/Shipments";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Users from "@/pages/Users";
import Warehouse from "@/pages/Warehouse";
import Pickups from "@/pages/Pickups";
import Chat from "@/pages/Chat";
import Track from "@/pages/Track";
import Addresses from "@/pages/Addresses";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/track" element={<Track />} />
          <Route path="/track/:trackingNumber" element={<Track />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/shipments" element={<ProtectedRoute><Shipments /></ProtectedRoute>} />
          <Route path="/shipments/:id" element={<ProtectedRoute><ShipmentDetail /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
          <Route path="/warehouse" element={<ProtectedRoute roles={["admin"]}><Warehouse /></ProtectedRoute>} />
          <Route path="/pickups" element={<ProtectedRoute roles={["admin"]}><Pickups /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute roles={["admin", "client"]}><Chat /></ProtectedRoute>} />
          <Route path="/addresses" element={<ProtectedRoute roles={["client", "admin"]}><Addresses /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
